import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import './CourseTable.css'; // Optional: For custom styles if needed
import plus_icon from "../../../assets/dashboard/plus-icon.svg"
import { getAllCourses } from '../../../services/Trainer/trainer';
import moment from 'moment';
// import ProgressDashes from './ProgressDashes';
import './profileTable.css'

const CourseTable = ({ courses, onDeclinePolicy, onAssignStaff,onAccept }) => {
  

    return (
        <div className="management-container">
           

            <div className="table-container">
                <table className="course-table">
                    <thead>
                        <tr>
                            <th colSpan="5">
                                <div className="profile-courses-table-header table-header">
                                    <div className="cell">Sr #</div>
                                    <div className="cell">Course Title</div>
                                    {/* <div className="cell">Reactions</div> */}
                                    {/* <div className="cell">Views</div> */}
                                    <div className="cell">Date of upload</div>
                                    <div className="cell">Is Approved</div>
                                    <div className="cell">Action</div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                         {
                            courses && courses?.length > 0 ?
                                <>
                                 {courses && courses.map((course,index) => (
                            <tr key={course._id}>
                                <td colSpan="5">
                                    <div className="profile-courses-table-row table-row">
                                        <div className="cell">{index+1}</div>
                                        <div className="cell">{course.title}</div>
                                        {/* <div className="cell viewed">{course.reactions}</div> */}
                                     {/* <div className="cell viewed"><ProgressDashes current={5} total={5} /></div> */}


                                        <div className="cell">{moment(course?.createdAt).format("DD-MM-YYYY")}</div>
                                        <div className="cell viewed">{course.isVerified ? "YES" :"NO"}</div>
                                        
                                        <div className="cell action">
                                            <button className="action-button" data-bs-toggle="dropdown">
                                                <i className="bi bi-three-dots"></i>
                                            </button>
                                            <div className="dropdown-menu">
                                                
                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onAccept(course._id);
                                                    }}
                                                >
                                                     <span className="text-success">Accept</span>
                                               <span className="icon-circle bg-success-subtle text-success ms-2">
                                                    <i className="bi bi-check-lg"></i>
                                                </span>
                                                </button>

                                                <button
                                                    className="delete-btn d-flex justify-content-between align-items-center w-100"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        onDeclinePolicy(course._id);
                                                    }}
                                                >
                                                    <span className="text-danger">Delete</span>
                                                    <span className="icon-circle bg-danger-subtle text-danger ms-2">
                                                        <i className="bi bi-trash-fill"></i>
                                                    </span>
                                                </button>

                                                {/* <hr className="my-2" /> */}

                                                {/* <button
                                                    className="assign-btn d-flex justify-content-between align-items-center w-100"
                                                    // onClick={(e) => {
                                                    //     e.stopPropagation();
                                                    //     onAssignStaff(course._id);
                                                    // }}
                                                >
                                                    <span className="text-secondary">Decline</span>
                                                    <img src={plus_icon} alt='plus' width={25} height={25} />
                                                </button> */}

                                                 {/* <button
                                                    className="assign-btn d-flex justify-content-between align-items-center w-100"
                                                    // onClick={(e) => {
                                                    //     e.stopPropagation();
                                                    //     onAssignStaff(course._id);
                                                    // }}
                                                >
                                                    <span className="text-secondary">Add</span>
                                                    <img src={plus_icon} alt='plus' width={25} height={25} />
                                                </button> */}

                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                                </>
                                :
                                <div
                className="col-md-12"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px', // Adjust as needed
                  gap: '8px',
                  fontSize: '18px',
                  color: '#666'
                }}
              >
                <i className="bi bi-info-circle" style={{ fontSize: '20px' }}></i>
                No records found
              </div>
                        }
                       
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default CourseTable;
